// extracted by mini-css-extract-plugin
export default {"footer":"footer__2I-p5","footer__consents":"footer__consents__Uy-9u","fade-in":"fade-in__2wWOr","fade-out":"fade-out__3ldEL"};